import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import { useFormikWizard } from "formik-wizard";
import 'setimmediate';
import _ from "lodash";
import 'core-js/es7/object';
const fetch = require("node-fetch");
/**
 * 
 * @todo
 * - Error handling if service is down
 * - Error handling if dynamics is not returning anything
 * - General error handling
 * -- use the set state to determine if error or not
 */

const routeSchedules = {
  'MA': 'monday-a',
  'MB': 'monday-b',
  'TUA': 'tuesday-a',
  'TUAN': 'tuesday-a',
  'TUB': 'tuesday-b',
  'TUBN': 'tuesday-b',
  'WA': 'wednesday-a',
  'WAN': 'wednesday-a',
  'WB': 'wednesday-b',
  'WBN': 'wednesday-b',
  'THA': 'thursday-a',
  'THAN': 'thursday-a',
  'THB': 'thursday-b',
  'THBN': 'thursday-b',
  'FA': 'friday-a',
  'FAN': 'friday-a',
  'FB': 'friday-b',
  'FBN': 'friday-b'
}

function BackToStart(){
  window.location.reload()
}
function GWCollectionResults() {
  const { errors, touched, handleBlur, handleChange } = useFormikContext();
  const { values } = useFormikWizard();
  //const { values } = useFormikWizard();
  //console.log(values)
  /**
  * Retrieve subscriptions from WebService
  */
    const [GetSubscriptionsWS, setGetSubscriptionsWS] = useState(0);
    const [GetSubscriptionsD365, setGetSubscriptionsD365] = useState(0);
    const [GetNextCollectionScheduleWS, setGetNextCollectionScheduleWS] = useState(0);
    const [GetGardenWaste, setGetGardenWaste] = useState();
    const [GetCollectionScheduleWS, setGetCollectionScheduleWS] = useState(0);
    const [SubsDown, setSubsDown] = useState();
    const [RefuseCollection, setRefuseCollection] = useState();
    const [D365Down, setD365Down] = useState();
    const [routePDFURL, setRoutePDFURL] = useState('www.southglos.gov.uk');

    useEffect(() => {

      fetch(`https://webapps.southglos.gov.uk/Webservices/SGC.GreenWasteService/GetLiveSubscribers.svc/getsubs/${values.address.addressSelect}`)
      .then((response) => {
        console.log(response.ok)
        if(response.ok){
          return response.json(); 
        } else {
          setSubsDown(true);
          return response.json();
        }
      })
      
        .then((getSubs) => {
          setGetSubscriptionsWS(getSubs);
        
           /**
           * Retrieve GW subscriptions from Dynamics
           * 
           * PROD: https://prod-25.uksouth.logic.azure.com/workflows/f00fbf34211b472a8a4215a2029754f0/triggers/manual/paths/invoke/UPRN/${values.address.addressSelect}?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=a6JqKw91_LRQDWo-z1TnpblqGqhTzj2oFLlW0BvZ3gE
           * TEST: https://prod-16.uksouth.logic.azure.com/workflows/7453ad1d682c4cf393fc6b68dd0fdb76/triggers/manual/paths/invoke/UPRN/${values.address.addressSelect}?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=eAvqVq81fDjQlRtpEnT_AxhhQYLPt73g5Bq-Doc15ik
           *
           */
         
            fetch(`https://prod-25.uksouth.logic.azure.com/workflows/f00fbf34211b472a8a4215a2029754f0/triggers/manual/paths/invoke/UPRN/${values.address.addressSelect}?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=a6JqKw91_LRQDWo-z1TnpblqGqhTzj2oFLlW0BvZ3gE`)
              .then((response) => {
                console.log(response.ok)
                if(response.ok){
                  return response.json(); 
                } else {
                  /**D365 might be down as response ok is not in 2xx range, but the rest of the code should continue */
                  setD365Down(true);
                  return response.json(); 
                }
              })
                .then((getD365Subs) => {
                  setGetSubscriptionsD365(getD365Subs);
               
                   /**
                   * Retrieve collection scheduele from WebService
                   */
                  
                    let CollectionScheduleFormatted;
                   
                    
                      fetch(`https://webapps.southglos.gov.uk/Webservices/SGC.RefuseCollectionService/RefuseCollectionService.svc/getCollections/${values.address.addressSelect}`)
                      .then((response) => {
                        console.log(response.ok)
                        if(response.ok){
                          return response.json(); 
                        } else {
                          setRefuseCollection(true);
                          return response.json();
                        }
                      })
                        .then((getCollectionScheduele) => {
                          if(getCollectionScheduele){
                            //console.log(getCollectionScheduele)
                            
                            let route = getCollectionScheduele[0]['CalendarName'];
                            setRoutePDFURL(`www.southglos.gov.uk/${routeSchedules[route]}`)
                            let gardenDates = false;
                            if( getCollectionScheduele[0]['G1'] && getSubs.length > 0 || getCollectionScheduele[0]['G2'] && getSubs.length > 0 || getCollectionScheduele[0]['G3'] && getSubs.length > 0 || getD365Subs.length > 0) {
                              gardenDates = true;
                              setGetGardenWaste(1);
                            }
  
                            //@todo check in original code if var found is relevant?
  
                            let blackBinCheck;
                            let text;
                            let collections = [];
  
                           // console.log(Array.isArray(getCollectionScheduele))
                            delete getCollectionScheduele[0]['CalendarName']
                           // for(const property in getCollectionScheduele){
                            for(let [key,value] of Object.entries(getCollectionScheduele[0])){
                              if(key){
                                if(key.indexOf("G") < 0){
                                  if(key.indexOf("R") >= 0){
                                    text = 'Recycling, food bin, black bin';
                                    if (gardenDates) text += ', garden waste';
                                  } else {
                                    text = 'Recycling, food bin';
                                  }
  
                                   let date    = new Date(value.split("/").reverse().join("-"));
                                   let days    = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                                   let months  = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
   
                                   collections.push({
                                     date: date,
                                     date_display: days[date.getDay()] + " " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear(),
                                     text: text
                                   });
                                  
                                }
  
                              }
                            }
                            
                            collections.sort(function(a,b){
                              return new Date(a.date).getTime() - new Date(b.date).getTime()
                            });
                            console.log(collections);
  
                            let nextCollection = collections[0];
                            collections.splice(0,1);
                            console.log(nextCollection);
                            console.log(collections);
                            setGetNextCollectionScheduleWS(nextCollection);
                            setGetCollectionScheduleWS(collections);
                            
                            console.log(GetSubscriptionsWS)
                            console.log(GetSubscriptionsD365)
  
                          } else {
                            console.log('We can\'t find collections to match that address. This may be because you live in a new property which is not in our database yet.')
                          }
                          
                        })
                   
                })
        })
       
        
    }, []);
  return (
    <div>
      {!RefuseCollection && 
        <div id="nextCollection">
          <div className="highlight">
            <p>Your next collection is:</p>
            <div style={{backgroundColor: "white", padding: "25px"}} >
              <p className="heading2">{GetNextCollectionScheduleWS['date_display']}</p>
              <p style={{marginBottom: "0px"}} className="heading3">{GetNextCollectionScheduleWS['text']}</p>
            </div>
          </div>
          <div className="upcomingcollections">
            <h2>Collections</h2>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Collections</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(GetCollectionScheduleWS).map(([key, value]) => {
                  return (
                    <tr>
                      <td>{value["date_display"]}</td>
                      <td>{value["text"]}</td>
                    </tr>         
                  );
                })}
              </tbody>
            </table>
          </div>
          <a href={"https://"+routePDFURL} style={{color:'#00709e', textDecoration: 'underline'}}>View or print your collection calendar</a>
          <p style={{paddingTop: '1.25rem'}}>If you are on the soft plastics trial, put them out for collection on the same day as your other recycling. </p>
        </div>
      }
      {
      /**
       * Issue with RefuseCollection api call or the Subs Call
       */
      RefuseCollection || SubsDown &&
        <div id="collectionProblem">
          <h2>There was a problem</h2>
          <p>We can't find collections that match '{values.postcode.postcode}'. There was a problem fetching the data.</p>
          <p>Try again later.</p>
        </div>
      }
        <h2>Garden waste subscriptions</h2>
        {D365Down &&
        <div className="alert__message alert--state-danger">
          <p>We cannot display all garden waste subscriptions at the moment.</p>
          <p>Try again later.</p>
        </div>
        }
        {_.isEmpty(GetSubscriptionsWS) && _.isEmpty(GetSubscriptionsD365) && 
        <div id="noGwSubsFounds">
          <p>No garden waste subscriptions were found.</p>
          <a href="https://www.southglos.gov.uk/form_newgreenwaste" style={{color:'#00709e', textDecoration: "underline"}}>Apply online</a>
        </div>
        }
        {
        /**@todo
         * Add check to not render table if getsubws/getsubd365 AND d365down
         */
         GetGardenWaste &&
          <>
            <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>How many bins</th>
                    <th>Expiration date</th>
                    <th>Renew subscription online</th>
                  </tr>
                </thead>
                <tbody>
                {Object.entries(GetSubscriptionsWS).map(([key, value]) => {
                  return (
                    <tr className="foe-entry">
                      <td>{value["BinsSubscribed"]}</td>
                      <td>{value["ExpiryDate"]}</td>
                      <td><a href="https://www.southglos.gov.uk/form_renewgreenwaste">Renew online</a></td>
                    </tr>
                  )
                })}
                {!D365Down &&
                Object.entries(GetSubscriptionsD365).map(([key, value]) => {
                  return (
                    <tr className="d365-entry">
                      <td>{value["BinsSubscribed"]}</td>
                      <td>{value["ExpiryDate"]}</td>
                      <td><a href="https://www.southglos.gov.uk/form_renewgreenwaste">Renew online</a></td>
                    </tr>
                  )
                })}
                </tbody>
            </table>
          </>
        }
        <p><a onClick={BackToStart} className="prev-btn" style={{cursor: "pointer"}}>Start again</a></p>
      </div>
    
  );
}
export default GWCollectionResults;

